import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { CALENDAR_EN, CALENDAR_IT } from 'src/app/shared/constants/app.constants';
import { CalendarConfig } from '../../models/general/calendar-config';
import { FormGroup } from '@angular/forms';
import { DynTableBadgeType } from 'src/app/shared/components/dyn-table';
import { Moment } from 'moment';
import * as moment from 'moment';

@Injectable()
export class UtilsService {

  constructor(
    private translate: TranslateService) {
  }

  getDynTableBasicLabels() {
    return {
      ricercaHeader: this.translate.instant('Ricerca'),
      filtraBtnLabel: this.translate.instant('Filtra'),
      resetBtnLabel: this.translate.instant('Reset'),
      totali: this.translate.instant('Totali'),
      mostrati: this.translate.instant('Mostrati'),
      di: this.translate.instant('di'),
      azioniHeader: this.translate.instant('Azioni')
    };
  }

  fireAskConfirmMsg(title: string): Promise<SweetAlertResult<unknown>> {
    return Swal.fire({
      icon: 'question',
      title: this.translate.instant(title),
      inputAttributes: { autocapitalize: 'off' },
      showCancelButton: true,
      cancelButtonText: this.translate.instant('Annulla'),
      reverseButtons: true,
      allowOutsideClick: () => !Swal.isLoading()
    });
  }

  fireConfirmationMsg(title: string, text?: string) {
    Swal.fire({
      icon: 'success',
      title: this.translate.instant(title),
      text: text ? this.translate.instant(text) : '',
      showConfirmButton: false,
      showCancelButton: false,
      timer: 1300
    }).then();
  }

  fireWarningMsg(title: string, text?: string) {
    Swal.fire({
      icon: 'warning',
      title: this.translate.instant(title),
      text: text ? this.translate.instant(text) : '',
      showConfirmButton: false,
      showCancelButton: false,
      timer: 1300
    }).then();
  }

  fireErrorConfirmMsg(title: string, text?: string, autoClose = false, showCancelBtn = false): Promise<SweetAlertResult<unknown>> {
    return Swal.fire({
      icon: 'error',
      title: this.translate.instant(title),
      text: text ? this.translate.instant(text) : '',
      showConfirmButton: !autoClose,
      showCancelButton: !autoClose && showCancelBtn,
      timer: autoClose ? 1000 : null
    });
  }

  getCalendarLocale(codeLang: string): CalendarConfig {
    if (codeLang === 'en' || codeLang === 'gb') {
      return CALENDAR_EN;
    }
    if (codeLang === 'it') {
      return CALENDAR_IT;
    }
  }

  /* Converte un numero in una stringa con 'decimals' cifre decimali, separate da virgola */
  convertToDecimalString(num: number, decimals: number) {
    num ? num = Number(num) : num;
    return num != null && num != undefined ? num.toLocaleString('it', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : null;
  }

  /* Converte un numero in una stringa senza cifre decimali */
  convertInteger(num: number) {
    return num != null && num != undefined ? num.toLocaleString('it') : null;
  }

  /* Converte un campo di un formGroup in una stringa con 'decimals' cifre decimali, separate da virgola */
  convertFormFieldToDecimalString(form: FormGroup, field: string, decimals: number) {
    let stringNum: string = form.get(field).value;
    if (stringNum !== '' && stringNum !== null) {
      stringNum = stringNum.replace(/\./g, '').replace(',', '.');
      form.get(field).setValue(this.convertToDecimalString(Number(stringNum), decimals));
    } else {
      form.get(field).setValue(null);
    }
  }

  stringItFormatToNumber(stringNum: string) {
    return stringNum !== null && stringNum !== undefined ? Number(stringNum.split('.').join('').replace(',', '.')) : null;
  }

  /**
   * Ritorna una stringa html per badge true/false dentro dyn-table
   */
  getBadge(val: boolean, valTrue: string, valFalse: string): string {
    if (val !== null) {
      return val === true ? DynTableBadgeType.SUCCESS + this.translate.instant(valTrue)
        : DynTableBadgeType.DANGER + this.translate.instant(valFalse);
    }
    return null;
  }

  /**
 * USARE QUESTO METODO SE SI VUOLE CONVERTIRE DA UN DATEPICKER --> DATA IN FORMATO STRINGA X BE
 * (è l'unico che mantiene la timezone corretta con l'orario inviando quindi la data corretta e non -2 ore)
 */
  public convertDateToStringUTC(date: Date): string {
    if (date) {
      return moment.utc({
        day: date.getDate(), month: date.getMonth(), year: date.getFullYear(),
        hours: date.getHours(), minutes: date.getMinutes(), seconds: date.getSeconds()
      }).toJSON();
    }
    return null;
  }

  /* Dato un form, setta tutti i tuoi campi come dirty, per attivare i messaggi di errore */
  public validateFormFields(form: FormGroup) {
    const keys = Object.keys(form.controls);
    keys.forEach((key: string) => { form.controls[key].markAsDirty() });
  }

}
